import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Work Log
export const createWorkLog = createAsyncThunk(
  'timeworkSheet/createWorkLog',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.post('/worklogs', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create work log');
    }
  }
);

// Update Work Log
export const updateWorkLog = createAsyncThunk(
  'timeworkSheet/updateWorkLog',
  async ({ workId, ...data }: any & { workId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/worklogs/${workId}`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update work log');
    }
  }
);
export const updateWorkLogByHr = createAsyncThunk(
  'timeworkSheet/updateWorkLog',
  async ({ workId, ...data }: any & { workId: number }, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.put(`/worklogs/updtae/byhr`, data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update work log');
    }
  }
);

// Delete Work Log
export const deleteWorkLog = createAsyncThunk(
  'timeworkSheet/deleteWorkLog',
  async ({ workId }: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.delete(`/worklogs/${workId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete work log');
    }
  }
);

// Fetch Work Log by ID
export const fetchWorkLogById = createAsyncThunk(
  'timeworkSheet/fetchWorkLogById',
  async ({ workId }: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/worklogs/${workId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch work log');
    }
  }
);

// Fetch All Work Logs
export const fetchAllWorkLogs = createAsyncThunk(
  'timeworkSheet/fetchAllWorkLogs',
  async (_, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get('/worklogs');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch work logs');
    }
  }
);

//Fetch All WorkLog by employeeID
export const fetchWorkLogsByEmployeeId = createAsyncThunk(
  "timeworkSheet/fetchWorkLogsByEmployeeId",
  async (employeeId: any, { rejectWithValue }) => {
    try {
      const response = await employeeServiceApiInstance.get(`/worklogs/employee/${employeeId}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || "Failed to fetch work logs for employee");
    }
  }
);
